import { Button } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import useMarketResearchStore from "./useMarketResearchStore";

export default function ChangeStudyButton() {
  const navigate = useNavigate();
  const { clearChatSession } = useMarketResearchStore();

  const handleChangeStudy = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    event.preventDefault();
    clearChatSession();
    navigate("/market-research");
  };

  return (
    <Link to={"/market-research"} onClick={handleChangeStudy} style={{ textDecoration: "none", color: "#003087" }}>
      <Button color="primary" sx={{ color: "#003087" }}>
        CHANGE STUDY
      </Button>
    </Link>
  );
}
